<template>
  <v-app>
    <TopNavbar />
    <v-main>
      <v-container fluid>
        <router-view />
      </v-container>
    </v-main>
    <AppFooter />
  </v-app>
</template>

<script>
import TopNavbar from "./components/TopNavbar.vue";
import AppFooter from "@/components/AppFooter.vue";
import { SET_SUMMARY_REPORT } from './store/actions/modelValidation';
import { mapActions } from "vuex";

export default {
  components: {
    TopNavbar,
    AppFooter,
  },
  methods: {
    ...mapActions({ getSummaryReport: SET_SUMMARY_REPORT }),
  },
  async created () {
    const userToken = localStorage.getItem("user-token");
    if (userToken) {
      // token validation on each enter to the UI
      await this.$modelValidationClient.test();      
    }
    if (userToken && !Object.keys(this.$store.getters.summaryReport)?.length) {
      await this.getSummaryReport()
    }
  },
};
</script>
